module.exports = __webpack_public_path__ + "img/29.83555aad.svg";